import React from "react";
import { MDBCard } from "mdb-react-ui-kit";

import "../../css/CategoryCard.css";

function CategoryCard({ tableCategories, heading }) {
  return (
    <div className="d-flex justify-content-center flex-column">
      <h1 className="categoryTitle">{heading}</h1>

      <div className="categoryContainer">
        {tableCategories ? (
          tableCategories.map((category, index) => {
            if (category["function category name"] !== "-") {
              return (
                <div className="categoryCardContainer" key={index}>
                  <MDBCard className="categoryCard">
                    <img
                      src={require(`../../images/grade-${category["average grade"]}-filled.png`)}
                      alt=""
                      className="gradeImg"
                    />
                    <div className="cardInfo">
                      <h5
                        style={{
                          color: category["color"],
                        }}
                      >
                        {category["function category name"]}
                      </h5>
                      <p>
                        Num of People:{" "}
                        <strong>{category["number of people"]} </strong>
                      </p>
                      <p className="cardInfo-avgScore">
                        The Average score for the category is{" "}
                        <strong>
                          {Math.floor(category["average score"] * 100)}%
                        </strong>
                      </p>
                    </div>
                  </MDBCard>
                </div>
              );
            } else {
              return (
                <div className="categoryCardContainer" key={index}>
                  <MDBCard className="categoryCard">
                    <img
                      src={require(`../../images/grade-${category["average grade"]}-filled.png`)}
                      alt=""
                      className="gradeImg"
                    />
                    <div className="cardInfo">
                      <h5
                        style={{
                          color: category["color"],
                        }}
                      >
                        No Category
                      </h5>
                      <p>
                        Num of People:{" "}
                        <strong>{category["number of people"]} </strong>
                      </p>
                      <p className="cardInfo-avgScore">
                        The Average score for the category is{" "}
                        <strong>
                          {Math.floor(category["average score"] * 100)}%
                        </strong>
                      </p>
                    </div>
                  </MDBCard>
                </div>
              );
            }
          })
        ) : (
          <>No Categories Available</>
        )}
      </div>
    </div>
  );
}

export default CategoryCard;
